/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import type { AnyAction } from '@reduxjs/toolkit';
import { handleActions } from 'redux-actions';

import type { CapabilitiesSlice } from '../../../../ts/state';

const initialState: CapabilitiesSlice = {
  loading: false,
  filter: '',
  items: {},
  details: {}
};

export const getCapabilitiesStart = (
  state: CapabilitiesSlice,
  action: AnyAction
): CapabilitiesSlice => ({
  ...state,
  loading: true,
  filter: action.payload.filter
});

export const getCapabilitiesSuccess = (
  state: CapabilitiesSlice,
  action: AnyAction
): CapabilitiesSlice => ({
  ...state,
  loading: false,
  items: action.payload.response.entities.capabilities || {}
});

export const getCapabilitiesError = (
  state: CapabilitiesSlice
): CapabilitiesSlice => ({
  ...state,
  loading: false,
  items: {}
});

export const getCapabilityStart = (
  state: CapabilitiesSlice
): CapabilitiesSlice => ({
  ...state,
  loading: true
});

export const getCapabilitySuccess = (
  state: CapabilitiesSlice,
  action: AnyAction
): CapabilitiesSlice => ({
  ...Object.assign({}, state, {
    details: action.payload.response.entities.capabilities || {}
  }), //merge the new details into existing,
  loading: false
});

export const getCapabilityError = (
  state: CapabilitiesSlice
): CapabilitiesSlice => ({
  ...state,
  loading: false
});

export const reducer = handleActions(
  {
    conversation: {
      capabilities: {
        getCapabilitiesStart,
        getCapabilitiesSuccess,
        getCapabilitiesError
      },
      capability: {
        getCapabilityStart,
        getCapabilitySuccess,
        getCapabilityError
      }
    }
  },
  initialState
);

export default reducer;
